(function () {
  const instances = new WeakMap();

  function initTuyaHero(hero) {
    if (!hero || instances.has(hero)) return;

    const sidebar = hero.querySelector(".tuya-hero__sidebar");
    const toggle = hero.querySelector(".tuya-hero__sidebar-toggle");
    let toggleHandler = null;
    const submenuHandlers = [];

    if (sidebar && toggle) {
      toggleHandler = function () {
        const isOpen = sidebar.classList.toggle("is-open");
        toggle.setAttribute("aria-expanded", isOpen);
      };
      toggle.addEventListener("click", toggleHandler);
    }

    const categoryMains = Array.from(
      hero.querySelectorAll(".tuya-hero__sidebar-item-wrapper--has-submenu .tuya-hero__sidebar-item-main")
    );

    categoryMains.forEach((main) => {
      const handler = function (e) {
        if (window.innerWidth >= 1025) return;

        e.preventDefault();
        e.stopPropagation();

        const wrapper = main.closest(".tuya-hero__sidebar-item-wrapper");
        if (wrapper) {
          const isOpen = wrapper.classList.contains("is-open");
          
          const allWrappers = hero.querySelectorAll(".tuya-hero__sidebar-item-wrapper");
          allWrappers.forEach((otherWrapper) => {
            if (otherWrapper !== wrapper) {
              otherWrapper.classList.remove("is-open");
              const otherBtn = otherWrapper.querySelector(".tuya-hero__sidebar-arrow-btn");
              if (otherBtn) {
                otherBtn.setAttribute("aria-expanded", "false");
              }
            }
          });

          wrapper.classList.toggle("is-open", !isOpen);
          const btn = main.querySelector(".tuya-hero__sidebar-arrow-btn");
          if (btn) {
            btn.setAttribute("aria-expanded", !isOpen);
          }
        }
      };
      main.addEventListener("click", handler);
      submenuHandlers.push({ element: main, handler });
    });

    const slides = Array.from(hero.querySelectorAll(".tuya-hero__slide"));
    const dots = Array.from(hero.querySelectorAll(".tuya-hero__dot"));
    const banner = hero.querySelector(".tuya-hero__banner");

    if (slides.length <= 1) {
      instances.set(hero, {
        destroy: function () {
          if (toggle && toggleHandler) {
            toggle.removeEventListener("click", toggleHandler);
          }
          submenuHandlers.forEach(({ element, handler }) => {
            element.removeEventListener("click", handler);
          });
          instances.delete(hero);
        },
      });
      return;
    }

    let currentIndex = slides.findIndex((slide) =>
      slide.classList.contains("active"),
    );
    let autoRotateInterval = null;

    if (currentIndex < 0) currentIndex = 0;

    function showSlide(index) {
      const nextIndex = Number(index);

      if (
        Number.isNaN(nextIndex) ||
        nextIndex < 0 ||
        nextIndex >= slides.length
      ) {
        return;
      }

      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle("active", slideIndex === nextIndex);
      });

      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle("active", dotIndex === nextIndex);
      });

      currentIndex = nextIndex;
    }

    function nextSlide() {
      showSlide((currentIndex + 1) % slides.length);
    }

    function stopAutoRotate() {
      if (!autoRotateInterval) return;

      window.clearInterval(autoRotateInterval);
      autoRotateInterval = null;
    }

    function startAutoRotate() {
      if (window.innerWidth <= 767) return;
      stopAutoRotate();
      autoRotateInterval = window.setInterval(nextSlide, 6000);
    }

    const dotHandlers = dots.map((dot, index) => {
      const handler = function () {
        showSlide(index);
        startAutoRotate();
      };

      dot.addEventListener("click", handler);

      return { dot, handler };
    });

    const onMouseEnter = stopAutoRotate;
    const onMouseLeave = startAutoRotate;

    let touchStartX = 0;
    let touchStartY = 0;

    function handleTouchStart(e) {
      if (window.innerWidth <= 767) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }

    function handleTouchEnd(e) {
      if (window.innerWidth <= 767) return;
      if (!touchStartX || !touchStartY) return;

      const diffX = e.changedTouches[0].clientX - touchStartX;
      const diffY = e.changedTouches[0].clientY - touchStartY;

      if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 40) {
        if (diffX > 0) {
          showSlide((currentIndex - 1 + slides.length) % slides.length);
        } else {
          showSlide((currentIndex + 1) % slides.length);
        }
        startAutoRotate();
      }

      touchStartX = 0;
      touchStartY = 0;
    }

    if (banner) {
      banner.addEventListener("mouseenter", onMouseEnter);
      banner.addEventListener("mouseleave", onMouseLeave);
      banner.addEventListener("touchstart", handleTouchStart, {
        passive: true,
      });
      banner.addEventListener("touchend", handleTouchEnd, { passive: true });
    }

    showSlide(currentIndex);
    startAutoRotate();

    instances.set(hero, {
      showSlide,
      startAutoRotate,
      stopAutoRotate,
      destroy: function () {
        stopAutoRotate();

        if (toggle && toggleHandler) {
          toggle.removeEventListener("click", toggleHandler);
        }

        submenuHandlers.forEach(({ element, handler }) => {
          element.removeEventListener("click", handler);
        });

        dotHandlers.forEach(({ dot, handler }) => {
          dot.removeEventListener("click", handler);
        });

        if (banner) {
          banner.removeEventListener("mouseenter", onMouseEnter);
          banner.removeEventListener("mouseleave", onMouseLeave);
          banner.removeEventListener("touchstart", handleTouchStart);
          banner.removeEventListener("touchend", handleTouchEnd);
        }

        instances.delete(hero);
      },
    });
  }

  function destroyTuyaHero(hero) {
    const instance = instances.get(hero);

    if (instance) {
      instance.destroy();
    }
  }

  function initAllTuyaHeroes(root) {
    const scope = root || document;
    const heroes =
      scope.matches && scope.matches('[data-tuya-section="hero"]')
        ? [scope]
        : Array.from(scope.querySelectorAll('[data-tuya-section="hero"]'));

    heroes.forEach(initTuyaHero);
  }

  document.addEventListener("DOMContentLoaded", function () {
    initAllTuyaHeroes(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initAllTuyaHeroes(event.target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    const hero =
      event.target.matches && event.target.matches('[data-tuya-section="hero"]')
        ? event.target
        : event.target.querySelector('[data-tuya-section="hero"]');

    destroyTuyaHero(hero);
  });

  document.addEventListener("shopify:block:select", function (event) {
    const slide = event.target.closest(".tuya-hero__slide");
    const hero = event.target.closest('[data-tuya-section="hero"]');
    const instance = instances.get(hero);

    if (!slide || !instance) return;

    instance.stopAutoRotate();
    instance.showSlide(slide.dataset.index);
  });

  document.addEventListener("shopify:block:deselect", function (event) {
    const hero = event.target.closest('[data-tuya-section="hero"]');
    const instance = instances.get(hero);

    if (instance) {
      instance.startAutoRotate();
    }
  });
})();
